// extracted by mini-css-extract-plugin
export var container = "toggleButton-module--container--f2097";
export var label = "toggleButton-module--label--9fad4";